module.exports = __webpack_public_path__ + "img/profitability5.4ccdf481.png";